import React from 'react'

const DeliveryIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="deliveryGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(100, 150, 255, 1)" />
          <stop offset="100%" stopColor="rgba(150, 100, 255, 1)" />
        </linearGradient>
        <filter id="deliveryGlow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Truck body */}
      <rect
        x="2"
        y="10"
        width="12"
        height="7"
        rx="1"
        stroke="url(#deliveryGradient)"
        strokeWidth="2"
        fill="rgba(100, 150, 255, 0.2)"
        filter="url(#deliveryGlow)"
      />
      
      {/* Truck cabin */}
      <path
        d="M14 10 L14 17 L18 17 L18 13 Z"
        stroke="url(#deliveryGradient)"
        strokeWidth="2"
        fill="rgba(100, 150, 255, 0.2)"
      />
      
      {/* Wheels */}
      <circle cx="7" cy="17" r="2" stroke="url(#deliveryGradient)" strokeWidth="1.5" fill="rgba(50, 100, 200, 0.3)" />
      <circle cx="16" cy="17" r="2" stroke="url(#deliveryGradient)" strokeWidth="1.5" fill="rgba(50, 100, 200, 0.3)" />
      
      {/* Speed lines */}
      <line x1="2" y1="8" x2="5" y2="8" stroke="url(#deliveryGradient)" strokeWidth="1" />
      <line x1="3" y1="6" x2="6" y2="6" stroke="url(#deliveryGradient)" strokeWidth="1" />
      
      {/* Package in truck */}
      <rect x="5" y="12" width="3" height="3" rx="0.5" fill="rgba(255, 200, 100, 0.8)" />
    </svg>
  )
}

export default DeliveryIcon
